$(document).ready(function() {
    var fakecrop = new FakeCrop();
    var timeoutResize;
    fakecrop.init();
    $(window).resize(function() {
        clearTimeout(timeoutResize);
        timeoutResize = setTimeout(function() {
            fakecrop.init();
        }, 100);
    });
    var bestPictures = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('title'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
            url: '/search?type=product&q=%QUERY&view=json',
            wildcard: '%QUERY'
        }
    });
    $('#search-bar').typeahead({
        hint: true,
        highlight: true,
        minLength: 1
    }, {
        name: 'best-pictures',
        display: 'title',
        source: bestPictures,
        templates: {
            suggestion: function(datum) {
                if (datum) {
                    return '<a href="' + datum.url + '">' + '<span class="thumbnail"><img src="' + datum.thumbnail + '"></span>' + '<span class="title">' + datum.title + '</span>' + '</a>';
                } else {
                    return '<p></p>';
                }
            }
        }
    });
});
$(document).ready(function() {
    $('.nt-product-item-price').has('strong').addClass('nt-has-sale-price');
});

function ntRemoveFromText() {
    jQuery('.nt-product-item-price').each(function() {
        jQuery(this).html(jQuery(this).html().replace('from', ''));
        jQuery(this).html(jQuery(this).html().replace('From', ''))
    })
}
jQuery(window).scroll(function() {
    var scrollTop = jQuery(this).scrollTop();
    var heightHeader = jQuery('header.site-header.header-sticky-enable').outerHeight();
    //jQuery('.template-index #shopify-section-header').css('height', heightHeader);
    if (scrollTop > (heightHeader + 300)) {
        jQuery('header.site-header.header-sticky-enable').addClass('fixed fadeInDown');
        jQuery('header.site-header.header-sticky-enable').removeClass('vertical-fixed');

    } else {
        jQuery('header.site-header.header-sticky-enable').removeClass('fixed fadeInDown');
        jQuery('header.site-header.header-sticky-enable').addClass('vertical-fixed');
    }
});

function initMobile() {
    if (jQuery(window).width() < 767) {
        $('body').addClass("nt-mobile");
        $('body').removeClass("nt-no-mobile");
    } else {
        $('body').addClass("nt-no-mobile");
        $('body').removeClass("nt-mobile");
    }
}
jQuery(document).ready(function() {
    initMobile();
    ntRemoveFromText();
});
jQuery(window).resize(function() {
    initMobile();
});
$(window).load(function() {
    $('.dropdown.mega-menu').hover(function() {
        $('.dropdown.mega-menu .col-collection').isotope({
            percentPosition: true,
            itemSelector: '.dropdown.mega-menu .inner',
            masonry: {}
        });
    });
  
    $('.filter-block .filter-title .fa').click(function(){
      $(this).parent('.filter-title').next('.filter-content').slideToggle();
    });

    if ($(window).width() >= 1200) {
        var heightHeader = jQuery('header.site-header.header-sticky-enable:not(.fixed)').outerHeight();
        jQuery('#site_header_wrap').css('height', heightHeader);
    }
});
$(document).ready(function() {
    var app = new App();
    app.init();
    toastr.options = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": false,
        "progressBar": false,
        "positionClass": "toast-top-right",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "200",
        "hideDuration": "500",
        "timeOut": "3000",
        "extendedTimeOut": "500",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    }
});
jQuery(window).load(function() {
    var imageShopify = new ImageShopify();
    imageShopify.initSetProductHeight();
})
jQuery(document).ready(function(jQuery) {
    jQuery("#back-top").hide();
    jQuery(function() {
        jQuery(window).scroll(function() {
            if (jQuery(this).scrollTop() > 100) {
                jQuery('#back-top').fadeIn();
            } else {
                jQuery('#back-top').fadeOut();
            }
        });
        jQuery('#back-top a').click(function() {
            jQuery('body,html').animate({
                scrollTop: 0
            }, 800);
            return false;
        });
    });
});

function is_mobile() {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
        return true;
    } else {
        return false;
    }
}
